import React from 'react'
import ProtectedLayout from './ProtectedLayout'
import PublicLayout from './PublicLayout'
export { ProtectedLayout, PublicLayout }


// WEBPACK FOOTER //
// ./src/layouts/index.ts